import { CheckCircle2 } from "lucide-react";
import KnowledgeBaseMoodVisual from "@/components/landing/KnowledgeBaseMoodVisual";
import { useLanguage } from "@/hooks/useLanguage";
import { Badge } from "@/components/ui/badge";

const KnowledgeBaseSection = () => {
  const { t, tArray } = useLanguage();
  const advantages = tArray('knowledgeBase.advantages');
  const sources = tArray('knowledgeBase.sources');
  
  return (
    <section id="wissensbasis" className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left - Visual */}
            <div className="relative order-2 lg:order-1">
              <KnowledgeBaseMoodVisual />
            </div>

            {/* Right - Content */}
            <div className="order-1 lg:order-2">
              <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t('knowledgeBase.tag')}</Badge>
              <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
                {t('knowledgeBase.title')}
              </h2>
              <p className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
                {t('knowledgeBase.titleLine2')}
              </p>
              <p className="text-lg text-chathero-orange font-semibold mb-6">
                {t('knowledgeBase.subtitle')}
              </p>
              
              <p className="text-muted-foreground mb-6 leading-relaxed">
                {t('knowledgeBase.description')}
              </p>

              <div className="bg-secondary/50 rounded-xl p-6 mb-6">
                <h3 className="font-semibold text-primary mb-3">{t('knowledgeBase.advantageTitle')}</h3>
                <ul className="space-y-2">
                  {advantages.map((advantage, index) => (
                    <li key={index} className="flex items-center gap-2 text-foreground">
                      <CheckCircle2 className="w-5 h-5 text-chathero-mint flex-shrink-0" />
                      <span>{advantage}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Data source badges */}
              <div className="flex flex-wrap gap-2">
                {sources.map((source) => (
                  <span 
                    key={source}
                    className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full"
                  >
                    {source}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KnowledgeBaseSection;